<template>
  <nav class="header">
    <div class="header-title">题目列表
      <span style="font-size: 15px;">（共{{length}}题）</span>
    </div>
    <div class="flex" v-if="checkShow">
      <div class="header-number">
      已选择
      <span class="header-number__color">
        {{pitchOnLength}}
      </span>
      题
    </div>
    <el-button @click="changeArrange(false)" class="header-close" plain>取消</el-button>
    </div>
      <el-tooltip effect="dark" content="请勾选需要布置的题目" placement="top" v-if="!isDisabled">
        <el-button type="primary" class="header-arrangement"
        icon="el-icon-plus" @click="changeArrange(true)"
        >
          布置错题巩固练习
        </el-button>
      </el-tooltip>
      <el-button type="primary" class="tooltip-hover" icon="el-icon-plus" v-else
        @click="changeArrange(true)">
          布置错题巩固练习
      </el-button>
  </nav>
</template>

<script>
export default {
  name: 'TopicContentHeader',
  props: {
    checkShow: {
      default: false,
    },
    pitchOnLength: {
      type: Number,
      default: 0,
    },
    length: {},
  },
  computed: {
    isDisabled() {
      return this.pitchOnLength > 0;
    },
  },
  methods: {
    changeArrange(type) {
      this.$emit('changeArrange', type);
    },
  },
};
</script>

<style lang="scss" scoped>
  .header {
    display: flex;
    margin-top: 30px;
    padding-left: 25px;
    .flex {
      display: flex;
    }
    &-title {
      flex: 1;
      text-indent: 15px;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      line-height: 40px;
      background: url('../../images/class_bg.png') no-repeat left center;
    }
    &-arrangement {
      align-self: flex-end;
    }
    &-close {
      width: 145px;
      margin: 0 10px;
    }
    &-number {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      line-height: 40px;
      font-weight: 500;
      color: #000000;
      &__color {
        color: #1890FF;
      }
    }
  }
</style>
